import Card from './RoleCard'
import Modal from './RoleModal'

export default {
    Card,
    Modal
}